import styled from 'styled-components';

export const AmenityInnerItemTextStylingSpan = styled.span(
  props => `
  margin-left: ${props.theme.spacing.small.s5};
`,
);

export const AmenityInnerItemIconStylingSpan = styled.span(
  props => `
  margin-top: ${props.theme.spacing.small.s5};
`,
);

export const DetailRoomAmenities = styled.div(
  props => `
      width: 100%;
      max-width: 120rem;
      display: flex;  
      margin: 0 auto 0;
  `
);

export const DetailAmenitiesInnerWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      flex-direction: column;
  `
);

export const AmenitesHeadWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      flex-direction: column;  
      padding-bottom: ${props.theme.spacing.large.l20};
  `
);

export const AmenitesHeadText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font22};
      color: ${props.theme.colors.black.base};
      font-weight: ${props.theme.font.fontWeight.black};
  `
);

export const AmenitiesHeadSubText = styled.p(
  props => `
      font-size: ${props.theme.font.large.font14};
      font-weight: ${props.theme.font.fontWeight.bold};
      color: ${props.theme.colors.grey.base};
      padding-top: ${props.theme.spacing.small.s4};
      span{
          color: ${props.theme.colors.green.dark}
      }
  `
);

export const AmenitiesDetailOuterWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      border: 0.07rem solid ${props.theme.colors.grey.lightba};
      border-radius: ${props.theme.misc.borderRadius.base};  
  `
);

export const AmenitiesDetailInnerWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      flex-direction: column;  
  `
);

export const AmenitesDetailHeadWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      align-items: center;
      padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l25};
      border-bottom: 0.07rem solid ${props.theme.colors.grey.lightba};
  `
);

export const AmenitiesDetailHeadList = styled.ul(
  props => `
      width: 100%;
      display: flex;
      list-style-type: none;
      
      li{
          width:25%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          color: ${props.theme.colors.grey.dark24}
          font-size: ${props.theme.font.large.font14};
          font-weight: ${props.theme.font.fontWeight.bold};
      }
  `
);

export const AmenitiesListInnerWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l25};
  `
);

export const AmenitiesBlockWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      // flex-direction: column;
      flex-flow: wrap;
  `
);

export const AmenitiesBlockInnerWrap = styled.div(
  props => `
      width: 25%;
      display: flex;
      flex-direction: column;  
      padding: ${props.theme.spacing.base} ${props.theme.spacing.nospacing};
  `
);

export const ListOuterWrapDiv = styled.div(
  props => `
    width:100%;
    height: auto;
  `
)

export const AmenitiesTypeHeadText = styled.p(
  props =>  `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.grey.dark24};
      font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const AmenitiesListInner = styled.ul(
  props =>   `
      width: 100%;
      display: flex;
      flex-direction: column;
      list-style-type: none; 
      padding: ${props.theme.spacing.base} ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l15}; 

      li{
          width:100%;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          padding-top: ${props.theme.spacing.small.s5};
          font-size: ${props.theme.font.large.font13};
          color: ${props.theme.colors.grey.base};
          line-height: ${props.theme.font.lineHeight.large};
      }
  `
);